// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"styles_searchInput__xjEIz","backButton":"styles_backButton__t7h_a","backIcon":"styles_backIcon__SyM9s"};